import { motion } from 'framer-motion'
import { FunctionComponent } from 'react'
import { Icon } from 'utils'

interface ErrorMessageInterface {
  isMultiple?: boolean
  isBottom?: boolean
}

const ErrorMessage: FunctionComponent<ErrorMessageInterface> = ({
  isBottom,
  isMultiple
}) => {
  return (
    <motion.div
      role="alert"
      className="wc-msg wc-msg--grey"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="wc-msg--has-icon">
        <div className="wc-msg__icon">
          <Icon
            role="presentation"
            id="#alert"
            width="40"
            height="35.395"
            fill="#f57e3a"
          />
        </div>
        <p>
          <b>
            Please review the field{isMultiple ? 's' : ''} marked in red{' '}
            {isBottom ? 'above' : 'below'}
          </b>
        </p>
      </div>
      <div className="mt-4">
        <p className="wc-msg__text">
          Please correct the error message{isMultiple ? 's' : ''} in red{' '}
          {isBottom ? 'above' : 'below'} to continue with your application
          process.
        </p>
      </div>
    </motion.div>
  )
}

export default ErrorMessage
